/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ key: NonNullable<unknown> }} Rename_Key_Changed_ToastInputs */

const en_rename_key_changed_toast = /** @type {(inputs: Rename_Key_Changed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Key changed to ${i?.key}. Old keys keep working.`)
};

const de_rename_key_changed_toast = /** @type {(inputs: Rename_Key_Changed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Schlüssel zu ${i?.key} geändert. Alte Schlüssel funktionieren weiterhin.`)
};

/**
* | output |
* | --- |
* | "Key changed to {key}. Old keys keep working." |
*
* @param {Rename_Key_Changed_ToastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rename_key_changed_toast = /** @type {((inputs: Rename_Key_Changed_ToastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rename_Key_Changed_ToastInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_rename_key_changed_toast(inputs)
	return en_rename_key_changed_toast(inputs)
});